export default "__VITE_ASSET__Cfax65T$__"